
import { defineComponent, reactive } from "vue";
import HeaderInfo from "../composables/HeaderInfo.vue";
import FooterInfo from "../composables/FooterInfo.vue";
import CardInput from "../components/CardInput.vue";
import CardScreen from "../components/CardScreen.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HeaderInfo,
    FooterInfo,
    CardInput,
    CardScreen,
  },
  setup() {
    const reactiveHand = reactive({
      hand: "",
    });

    return {
      reactiveHand,
    };
  },
});
